import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_CartDetails = _resolveComponent("CartDetails")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      id: "cart",
      type: "button",
      class: "btn btn-success",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showCartDetails=true))
    }, [
      _createVNode(_component_FontAwesomeIcon, { icon: _ctx.faCartShopping }, null, 8, ["icon"]),
      _createTextVNode(" " + _toDisplayString(_ctx.cart.items.length) + " items ", 1)
    ]),
    _createVNode(_component_b_modal, {
      "hide-footer": "",
      "hide-header": "",
      modelValue: _ctx.showCartDetails,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showCartDetails) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CartDetails, {
          onOrdercreated: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCartDetails=false))
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}